// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"178":"EditSwitch","189":"editor","938":"EditBtn","946":"Btn"}[chunkId] + "." + {"178":"cc06d7b6","189":"da7ba68c","938":"ec26e8cc","946":"d6089ff7"}[chunkId] + ".js";
};